<div class="{{ className() }}">
  <div class="border-neutral-grey-40 animate-spin rounded-full border-t-primary-blue-40" [ngStyle]="style()"></div>
</div>
